export default "__VITE_ASSET__3_0Xc$e5__"